import { reduce } from 'lodash'
import * as Yup from 'yup'
import {
  getVariantsLeadTime,
  getVariantsMinimumOrderQuantity,
} from '@public/Showroom/Products/Detail/utils'
import { productQuantitySchema } from 'constants/validationSchemas'
import { type CartContextItem } from 'providers/cart'

export const getProductQuantityFieldName = (id: number) =>
  `variantQuantity-${id}`

export const getProductQuantityInitialValues = ({
  cartItems,
}: {
  cartItems: CartContextItem[]
}) =>
  reduce(
    cartItems,
    (acc, { cartQuantity, productVariant: { id } }) => ({
      ...acc,
      [getProductQuantityFieldName(id)]: cartQuantity,
    }),
    {}
  )

export const getProductQuantityValidationSchema = ({
  cartItems,
}: {
  cartItems: CartContextItem[]
}) =>
  Yup.object().shape(
    reduce(
      cartItems,
      (acc, { productVariant: { id, quantity, managedCustomFields } }) => {
        const fieldName = getProductQuantityFieldName(id)
        const leadTime = getVariantsLeadTime({
          managedCustomFields,
        })

        return {
          ...acc,
          [fieldName]: productQuantitySchema({
            fieldName,
            minimumOrderQuantity: getVariantsMinimumOrderQuantity({
              managedCustomFields,
            }),
            availableQuantity: quantity,
            leadTime,
          }),
        }
      },
      {}
    )
  )
